<i18n lang='yml' src='../i18n/Asset.yml'></i18n>
<template>
  <div class="col-sm-12 col-md-6 col-xxl-4 d-flex">
    <figure class="thumbnail-wrap" :class="{ active: selected_assets.indexOf(asset.id) != -1}">
    <div v-if="public_page" >
      <img v-if="asset['has_preview?']" class="img-fluid" :src="`/en/public/${asset.id}/participics_preview/large`" :alt="`${asset.title}-img`" />
      <img v-else  class="img-fluid" :src="`${no_preview_path}`" alt="no-preview" />
    </div>
    <div v-else>
      <img v-if="asset['has_preview?']" class="img-fluid" :src="`/en/assets/${asset.id}/preview/large`" :alt="`${asset.title}-img`" />
      <img v-else class="img-fluid" :src="`${no_preview_path}`" alt="no-preview" />
    </div>
    <figcaption class="thumbnail-wrap-overlay">
      <ul class="list-inline list-unstyled list-options">
        <li class="asset-title">
          <a href="#" :class="`asset-title-${asset.id}`" :data-id="asset.id" :data-target="`#modal-network-digital-asset-${asset.id}`" data-toggle="modal">
            <h4>{{asset.title}}</h4>
          </a>
        </li>
      </ul>
      <ul class="list-inline list-unstyled list-options bottom">
        <li :class="edit == 'true' ? '' : 'asset-title'">
          <a v-if="edit =='true'" class="btn btn-light" :href="`assets/${asset.id}/edit`">
            {{ $t('edit') }}
          </a>
          <label v-else class="check-select" :for="`select_asset_${asset.id}`">
            <input  type="checkbox" :checked="selected_assets.indexOf(asset.id) != -1" :id="`select_asset_${asset.id}`" @click="$emit('selected', asset.id)">
            {{selected_assets.indexOf(asset.id) != -1 ? $t('deselect') : $t('select') }}
          </label>
        </li>
      </ul>
    </figcaption>
  </figure>    
  </div>
</template>
<script>

export default {
  props: ['asset', 'locale', 'no_preview_path', 'edit', 'selected_assets', 'public_page'],
}
</script>
